import { Button } from "components/shadcn/ui/button";
import React from "react";

const Home: React.FC = () => {
  const loginUrl = `${process.env.REACT_APP_CLERK_PRIMARY_APP_URL}/sign-in#/?redirect_url=${process.env.REACT_APP_SELLER_APP_URL}?app=seller`;
  const handleLogin = () => {
    window.location.href = loginUrl;
  };

  return (
    <div
      className="flex justify-center flex-col gap-4 items-center"
      style={{ textAlign: "center", marginTop: "20%" }}
    >
      <h1 className="font-bold text-primary-700">
        Welcome to BizCrunch Seller App
      </h1>
      <p>
        Please click on the Sign in button to continue using the seller app.
      </p>
      <Button variant={"primary"} onClick={() => handleLogin()}>
        Sign in
      </Button>
    </div>
  );
};

export default Home;
